<template>
    <LoadingComponent :props="loading" />

    <div id="notify" class="db-tab-div font-medium active">
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5 border rounded-lg p-3 bg-white border rounded-md p-3">
            <button @click="selectActive(index)"
                class=" db-tab-sub-btn w-full flex items-center gap-3 h-10 px-4 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5"
                v-for="(notificationAlert, index) in  enums.notificationAlertObject" :key="notificationAlert"
                :data-tab="'#' + notificationAlert.slug" :class="index === selectIndex ? 'active' : ''">
                <i class="lab lab-line-mail text-sm" v-if="notificationAlert.slug === 'mail'"></i>
                <i class="lab lab-line-sms text-sm" v-if="notificationAlert.slug === 'sms'"></i>
                <i class="lab lab-line-notification text-sm" v-if="notificationAlert.slug === 'push_notification'"></i>
                <span class="whitespace-nowrap text-[15px]">{{ notificationAlert.name }}</span>
            </button>
        </div>
        <div :id="notificationAlert.slug" class="db-card db-tab-sub-div"
            v-for="(notificationAlert, index) in  enums.notificationAlertObject" :key="notificationAlert"
            :class="{ 'active': index === selectIndex, 'on-update': onUpdateActive && index === selectIndex }">
            <div class="db-card-header items-center justify-between gap-4">
                <h3 class="db-card-title" v-if="notificationAlert.slug === 'push_notification'">
                    {{ $t("label.messages") }} / {{ notificationAlert.name }}</h3>
                <h3 class="db-card-title" v-else>
                    {{ $t("label.messages") }} / {{ $t("label.notifications") }} {{ notificationAlert.name }}</h3>
                <div class="flex items-center gap-2">
                    <button
                        type="button"
                        class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                        @click="refreshFromServer"
                        :disabled="isRefreshingView"
                        :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                    >
                        <template v-if="isRefreshingView">
                            <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                            </svg>
                        </template>
                        <template v-else>
                            <i class="fa-solid fa-arrows-rotate"></i>
                        </template>
                    </button>
                </div>
            </div>

            <div class="db-card-body" v-if="notificationAlert.slug === 'mail'">
                <form @submit.prevent="save(notificationAlert.slug, index)"
                    :id="'formElem_' + notificationAlert.slug + index" class="w-full d-block">
                    <div class="form-row">
                        <div class="form-col-12 sm:form-col-6" v-for="notification in notificationAlerts" :key="notification">
                            <div class="flex items-center justify-start gap-2 mb-2">
                                <div class="custom-switch">
                                    <input @click="selectCheckbox($event, notificationAlert.slug, notification.id)"
                                        :id="notificationAlert.slug + notification.id" type="checkbox"
                                        :value="notification.mail" :name="notificationAlert.slug + notification.id"
                                        :checked="notification.mail === enums.switchEnum.ON">
                                </div>
                                <label class="text-sm">{{ $t("label."+notification.language) }}</label>
                            </div>
                            <textarea :name="notification.id"
                                class="block w-full h-14 rounded-lg py-2 px-3 resize-none font-normal border transition border-[#EFF0F6] focus-within:border-primary/20">{{ notification.mail_message }}</textarea>
                        </div>
                        <input type="hidden" name="type" :value="notificationAlert.slug">
                        <div class="form-col-12 border-t pt-5 mt-3">
                            <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                                <template v-if="isSaving">
                                    <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                        <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                    </svg>
                                    <span>{{ $t('button.updating') }}</span>
                                </template>
                                <template v-else>
                                    <i class="lab lab-fill-save"></i>
                                    <span>{{ $t("label.save") }}</span>
                                </template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="db-card-body" v-if="notificationAlert.slug === 'sms'">
                <form @submit.prevent="save(notificationAlert.slug, index)"
                    :id="'formElem_' + notificationAlert.slug + index" class="w-full d-block">
                    <div class="form-row">
                        <div class="form-col-12 sm:form-col-6" v-for="notification in notificationAlerts" :key="notification">
                            <div class="flex items-center justify-start gap-2 mb-2">
                                <div class="custom-switch">
                                    <input @click="selectCheckbox($event, notificationAlert.slug, notification.id)"
                                        :id="notificationAlert.slug + notification.id" type="checkbox" :value="notification.sms"
                                        :name="notificationAlert.slug + notification.id"
                                        :checked="notification.sms === enums.switchEnum.ON">
                                </div>
                                <label class="text-sm">{{ notification.name }}</label>
                            </div>
                            <textarea :name="notification.id"
                                class="block w-full h-14 rounded-lg py-2 px-3 resize-none font-normal border transition border-[#EFF0F6] focus-within:border-primary/20">{{ notification.sms_message }}</textarea>
                        </div>
                        <input type="hidden" name="type" :value="notificationAlert.slug">
                        <div class="form-col-12 border-t pt-5 mt-3">
                            <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                                <template v-if="isSaving">
                                    <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                        <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                    </svg>
                                    <span>{{ $t('button.updating') }}</span>
                                </template>
                                <template v-else>
                                    <i class="lab lab-fill-save"></i>
                                    <span>{{ $t("label.save") }}</span>
                                </template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="db-card-body" v-if="notificationAlert.slug === 'push_notification'">
                <form @submit.prevent="save(notificationAlert.slug, index)"
                    :id="'formElem_' + notificationAlert.slug + index" class="w-full d-block">
                    <div class="form-row">
                        <div class="form-col-12 sm:form-col-6" v-for="notification in notificationAlerts" :key="notification">
                            <div class="flex items-center justify-start gap-2 mb-2">
                                <div class="custom-switch">
                                    <input @click="selectCheckbox($event, notificationAlert.slug, notification.id)"
                                        :id="notificationAlert.slug + notification.id" type="checkbox"
                                        :value="notification.push_notification" :name="notificationAlert.slug + notification.id"
                                        :checked="notification.push_notification === enums.switchEnum.ON">
                                </div>
                                <label class="text-sm">{{ notification.name }}</label>
                            </div>
                            <textarea :name="notification.id"
                                class="block w-full h-14 rounded-lg py-2 px-3 resize-none font-normal border transition border-[#EFF0F6] focus-within:border-primary/20">{{ notification.push_notification_message }}</textarea>
                        </div>
                        <input type="hidden" name="type" :value="notificationAlert.slug">
                        <div class="form-col-12 border-t pt-5 mt-3">
                            <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                                <template v-if="isSaving">
                                    <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                        <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                    </svg>
                                    <span>{{ $t('button.updating') }}</span>
                                </template>
                                <template v-else>
                                    <i class="lab lab-fill-save"></i>
                                    <span>{{ $t("label.save") }}</span>
                                </template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";
import switchEnum from "../../../../enums/modules/switchEnum";

export default {
    name: "NotificationAlertComponent",
    components: { LoadingComponent },
    data() {
        return {
            loading: {
                isActive: false,
            },
            enums: {
                switchEnum: switchEnum,
                notificationAlertObject: [
                    {
                        name: this.$t("label.mail"),
                        slug: "mail"
                    },
                    {
                        name: this.$t("label.sms"),
                        slug: "sms"
                    },
                    {
                        name: this.$t("label.push_notification"),
                        slug: "push_notification"
                    },
                ],
            },
            selectIndex: 0,
            isSaving: false,
            isRefreshingView: false,
            onUpdateActive: false,
            form: {
                license_key: "",
            },
            errors: {},
        };
    },
    mounted() {
        try {
            this.loading.isActive = true;
            this.$store.dispatch("notificationAlert/lists").then((res) => {
                this.loading.isActive = false;
            }).catch((err) => {
                this.loading.isActive = false;
            });
        } catch (err) {
            this.loading.isActive = false;
            alertService.error(err);
        }
    },
    computed: {
        notificationAlerts: function () {
            return this.$store.getters["notificationAlert/lists"];
        },
    },
    methods: {
        selectActive: function (index) {
            this.selectIndex = index;
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.$store.dispatch("notificationAlert/lists").then((res) => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch((err) => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        selectCheckbox: function (e, slug, id) {
            document.getElementById(slug + id).value = e.target.checked ? 5 : 10;
        },
        save: function (slug, index) {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                let form = document.getElementById("formElem_" + slug + index);
                let formDataObj = {};
                [...form.elements].filter((el) => el.tagName !== 'BUTTON').forEach((item) => {
                    formDataObj[item.name] = item.value;
                });

                this.$store.dispatch("notificationAlert/save", { form: formDataObj }).then((res) => {
                    alertService.successFlip(res.config.method === "put" ?? 0, this.$t("menu.notification_alert"));
                    this.$store.dispatch("notificationAlert/lists").catch(() => {
                        // Ignore refresh errors after successful save.
                    });
                    this.errors = {};
                    this.isSaving = false;
                    this.onUpdateActive = false;
                }).catch((err) => {
                    this.errors = err.response.data.errors;
                    this.isSaving = false;
                    this.onUpdateActive = false;
                });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        },
    },
};
</script>
